import addError from '../../../utils/error.jsx';

export function request( customerId, data ) {
    return {
        type: 'CUSTOMERS_ADD_FREEBET_CREDITS_REQUEST',
        customerId,
        data
    };
}

export function error( customerId, errors ) {
    addError( errors );

    return {
        type: 'CUSTOMERS_ADD_FREEBET_CREDITS_ERROR',
        customerId,
        errors
    };
}

export function finish( customerId, data ) {
    return {
        type: 'CUSTOMERS_ADD_FREEBET_CREDITS_FINISH',
        customerId,
        data
    };
}
